/**
 * Utilidades para detectar el entorno actual
 */

/**
 * Detecta si estamos en un entorno de preview (staging/preview)
 */
export function isPreviewEnvironment(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  
  const hostname = window.location.hostname;
  
  // Detectar si estamos en preview por hostname
  // - preview.programatuviaje.cl (subdominio específico para preview)
  // - URLs de Vercel preview deployments (formato: proyecto-git-rama-usuario.vercel.app)
  return (
    hostname.startsWith('preview.') || // preview.programatuviaje.cl
    (hostname.includes('.vercel.app') && hostname.includes('-git-')) // Preview deployments de Vercel
  );
}

